import {
    drawerWidth,
    transition,
    dangerColor,
    primaryColor,
} from '../global';

const userLayoutStyle = (theme) => ({
    wrapper: {
        position: 'relative',
        top: '0',
        height: '100vh',
    },
    mainPanel: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        overflow: 'auto',
        position: 'relative',
        float: 'right',
        ...transition,
        width: '100%',
        overflowScrolling: 'touch',
        backgroundColor: (props) => props?.eventInfo?.settings_colors_viewer?.screen_background_color,
    },
    content: {
        flex: '1 0 auto',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    contentCustomLayout: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
    },
    map: {
        marginTop: '70px',
    },
    background: {
        height: '450px',
        [theme.breakpoints.down('sm')]: {
            height: '450px',
        },
        [theme.breakpoints.down('xs')]: {
            height: '250px',
        },
        maxHeight: '1000px',
        overflow: 'hidden',
        position: 'relative',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        margin: '0',
        padding: '0',
        border: '0',
        // display: 'grid',
    },
    header: {
        padding: '10px 24px 0 24px',
        display: 'flex',
        flexDirection: 'row',
        minHeight: '180px',
        overflow: 'hidden',
        position: 'relative',
        margin: '0',
        border: '0',
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    mainContent: {
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: `calc(100% - ${drawerWidth}px)`,
            '&>footer': {
                width: '100%',
            },
        },
    },
    userLogo: {
        padding: '24px 24px 100px 24px',
        [theme.breakpoints.down('sm')]: {
            padding: '24px',
        },
        cursor: 'pointer',
    },
    noImageLogo: {
        minWidth: `${drawerWidth}px`,
        // padding: '10px 24px 10px 24px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 24px 0px 24px',
        },
        cursor: 'pointer',
    },
    brand: {
        background: 'linear-gradient(to top, #03418e 30%, #31ccff 95%)',
        textShadow: `0 0 ${dangerColor}, -1px 0 white, 0 -1px white, 0 1px white, 1px 1px white, -1px -1px white, -1px 1px white, 1px 1px white`,
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
    },
    noImageBrand: {
        fontSize: '40px',
        background: 'linear-gradient(to top, #03418e 30%, #31ccff 95%)',
        textShadow: `0 0 ${dangerColor}, -1px 0 white, 0 -1px white, 0 1px white, 1px 1px white, -1px -1px white, -1px 1px white, 1px 1px white`,
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
    },
    backToTop: {
        display: 'none',
        zIndex: 9999,
        position: 'fixed',
        bottom: '15px',
        right: '15px',
        boxShadow: '0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)',
        backgroundColor: '#2FC8FE',
        '&:hover,&:focus': {
            color: '#FFFFFF',
            backgroundColor: primaryColor,
            boxShadow:
          '0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)',
        },
    },
    hiddenMenuText: {
        color: (props) => props?.eventInfo?.settings_colors_viewer?.contents_text_color || 'black',
        lineHeight: 1,
        marginTop: '-13px',
        fontSize: '14px',
        marginBottom: '10px',
        textAlign: 'center',
    },

    // css custom layout
    mainContentCustomLayout: {
        minHeight: 'calc(100vh - 59px - 180px - 146px - 41px)',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: `calc(100% - ${drawerWidth}px)`,
            margin: 'auto',
            '&>footer': {
                width: '100%',
            },
            marginTop: '50px',
        },
    },
    wrapperMobileCustomLayout: {
        overflowY: 'hidden',
    },
});

export default userLayoutStyle;
